import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-eb1873c8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "label" }
const _hoisted_2 = {
  key: 0,
  class: "value password"
}
const _hoisted_3 = {
  key: 1,
  class: "value"
}
const _hoisted_4 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: "info",
    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('onClickRow')))
  }, [
    _createElementVNode("p", _hoisted_1, _toDisplayString($props.label), 1 /* TEXT */),
    ($props.keyValue === 'JOIN.PASSWORD')
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          (_openBlock(), _createElementBlock(_Fragment, null, _renderList($setup.maskingPasswordLength, (number) => {
            return _createElementVNode("div", {
              key: number,
              class: "password-symbol"
            })
          }), 64 /* STABLE_FRAGMENT */))
        ]))
      : ($props.keyValue === 'JOIN.MEMBER_PHONE')
        ? (_openBlock(), _createElementBlock("p", _hoisted_3, _toDisplayString($setup.formattedPhoneNumber), 1 /* TEXT */))
        : (_openBlock(), _createElementBlock("p", {
            key: 2,
            class: "value",
            innerHTML: $props.value
          }, null, 8 /* PROPS */, _hoisted_4))
  ]))
}